import { gql } from "@apollo/client";

export const TECHNOLOGY_QUERY = gql`
    query Technology {
        ticketCount {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        mttr {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        uptime {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        securityIncidents {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        responseTime {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        fcr {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        sla {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        urgentTickets {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        ticketsPerDay {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }

        
        ticketsByStatus {
            items {
                category
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                ytdPct
                ytdValue
            }
        }
        ticketsByPriority {
            items {
                category
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                ytdPct
                ytdValue
            }
        }
        ticketsByImpactCategory {
            items {
                category
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                ytdPct
                ytdValue
            }
        }
        ticketsByClassification {
            items {
                category
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                ytdPct
                ytdValue
            }
        }
        top10CustomApps {
            items {
                category1
                category2
                mtdValue
                qtdValue
                ytdValue
            }
        }
        top10Submitters {
            items {
                category1
                category2
                mtdValue
                qtdValue
                ytdValue
            }
        }
        ticketCountByMonth {
            items {
                month
                values {
                    appGroup
                    value
                }
            }
        }


    }
`;

